export default {
  namespaced: true,

  state: {
    lastResizeTime: 0,
    heightPage: 0,
    heightHomeMain: 0,
    heightHomeContent: 0
  },

  mutations: {
    STORE_PAGE_HEIGHT_INFO(state, { page, homeMain, homeContent }) {
      state.heightPage = page;
      state.heightHomeMain = homeMain;
      state.heightHomeContent = homeContent;
      state.lastResizeTime = +new Date();
    }
  }
};
